import { ProgressSpinner } from "primereact/progressspinner";
import { Suspense } from "react";
import { Outlet } from "react-router";
import { MainLayout } from "./components/mainLayout";

export const PublicBase = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <ProgressSpinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const ProtectedBase = () => {
  return (
    <MainLayout isProtected>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <ProgressSpinner />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};
